import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  updateList,
  sendRequest,
  selectQueryParams,
  requestInProcess,
  requestFinished
} from '../../../../../../common/reducers/list/reducer';

import { insertUpdateItems as insertUpdateObjectCollectionItems } from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksService from '../../../../services/TasksService';

function* getTasksListAsOwner(reducerName) {
  yield put(requestInProcess(reducerName));
  const queryParams = yield select(selectQueryParams, reducerName);
  try {
    const result = yield call(
      timeoutCall,
      TasksService.getTasksListAsOwner,
      queryParams
    );
    if (result.response) {
      if (result.response.status) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.tasksById,
            itemsIds: result.destructData.tasksIds,
            pagination: result.destructData.pagination
          })
        );
        yield put(
          insertUpdateObjectCollectionItems(
            'tasksModule.collections.tasksCollection',
            result.destructData.tasksById
          )
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName, status));
}

export default function createSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, getTasksListAsOwner, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/lists/sagas/tasksListAsOwnerSaga.js